import { render, staticRenderFns } from "./EmptyDispatchIcon.vue?vue&type=template&id=06586e6a"
import script from "./EmptyDispatchIcon.vue?vue&type=script&lang=js"
export * from "./EmptyDispatchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports